import { Box } from '@/components/ui/lib/box';
import { Flex } from '@/components/ui/lib/flex';
import DashboardNav from '@/app/components/dashboard-nav';
import { DASHBOARD_CONTENT_MAX_WIDTH } from '@/config/constants';
import type { DashboardRouteLayoutProps } from '@/app/types/dashboard-route-layout';

const DashboardRouteLayout = ({ children, allowOverflow = false }: DashboardRouteLayoutProps) => (
  <Box
    as="section"
    h="100vh"
    overflowY="hidden"
    overflowX={allowOverflow ? 'visible' : 'hidden'}
    className="bg-subtle"
  >
    <Flex h="100vh" align="stretch" flexDirection="row">
      <DashboardNav />
      {/*
        The scroll container stays full width so its scrollbar sits against the edge of the screen;
        the cap lives on the inner column instead. `h="full"` keeps the column height definite so
        the page shell's `minH` percentage still resolves.
      */}
      <Box
        flex="1"
        minW="0"
        overflowY="auto"
        overflowX={allowOverflow ? 'visible' : 'hidden'}
        p={{ base: '4', md: '6', xl: '8' }}
      >
        <Box h="full" w="full" maxW={DASHBOARD_CONTENT_MAX_WIDTH} mx="auto">
          {children}
        </Box>
      </Box>
    </Flex>
  </Box>
);

export default DashboardRouteLayout;
